module.exports = __webpack_public_path__ + "assets/img/home_down.268c573a.png";